// extracted by mini-css-extract-plugin
export default {"idNoIcon":"styles_idNoIcon__2Zh-N"};